import { type ToolbarContext } from './toolbar_context'

export function buildToolbarUrl(ctx: ToolbarContext, liveCtx: HTMLElement | null): string {
  const params = new URLSearchParams({ project_id: String(ctx.project_id) })

  if (ctx.active_app) {
    params.set('active_app', String(ctx.active_app))
  } else if (liveCtx?.dataset.originActiveApp && String(ctx.project_id) === String(liveCtx.dataset.originProjectId)) {
    params.set('active_app', liveCtx.dataset.originActiveApp)
  }

  if (ctx.include_survey_portal_check) {
    params.set('include_survey_portal_check', 'true')
  }

  if (ctx.redirect_route) {
    params.set('redirect_route', JSON.stringify(ctx.redirect_route))
  }

  return `/widget/project_toolbar?${params}`
}

export function startObserving(onChange: () => void): { disconnect(): void; reobserve(): void } {
  const bodyObserver = new MutationObserver((mutations) => {
    deduplicateToolbarContext(mutations)
    onChange()
  })
  bodyObserver.observe(document.body, { childList: true, subtree: true })

  let contextObserver: MutationObserver | null = null

  function observeContext() {
    contextObserver?.disconnect()
    const ctx = document.getElementById('toolbar-context')
    if (!ctx) return
    contextObserver = new MutationObserver(onChange)
    contextObserver.observe(ctx, { attributes: true, attributeFilter: ['data-value', 'data-revision'] })
  }

  observeContext()

  return {
    disconnect() {
      bodyObserver.disconnect()
      contextObserver?.disconnect()
    },
    reobserve: observeContext
  }
}

function deduplicateToolbarContext(mutations: MutationRecord[]) {
  let newCtx: Element | null = null

  for (const mutation of mutations) {
    for (const node of mutation.addedNodes) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue
      const el = node as Element
      if (el.id === 'toolbar-context') {
        newCtx = el
      } else {
        const found = el.querySelector?.('#toolbar-context')
        if (found) newCtx = found
      }
    }
  }

  if (!newCtx) return

  document.querySelectorAll('#toolbar-context').forEach((el) => {
    if (el !== newCtx) el.remove()
  })
}
